import React, {useEffect, useState} from "react";

// import AdvisoryNotice from "components/AdvisoryNotice";
import Head from "next/head";
import HeaderV2 from "components/HeaderV2";
import HeroSection from "components/PartnerHomePageNew/HeroSection";
import PartnerGlobalStyle from "static/next/css/PartnerGlobalStyle";
import {SegmentAnalytics} from "components";
import {NewThankYou} from "components/commons";
import {ToastContainer} from "react-toastify";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import styled from "styled-components";

const Register = dynamic(() => import("components/NewPartners/Register"), {ssr: false});
const GetStartedModal = dynamic(() => import("components/commons/Login/GetStartedModal"), {ssr: false});
const StatsSection = dynamic(() => import("components/PartnerHomePageNew/StatsSection"));
const HowWealthyHelps = dynamic(() => import("components/PartnerHomePageNew/HowWealthyHelps"));
const HomePageFeatures = dynamic(() => import("components/PartnerHomePageNew/HomePageFeatures"));
const CreateBrand = dynamic(() => import("components/PartnerHomePageNew/CreateBrand"));
const PartnerPriority = dynamic(() => import("components/PartnerHomePageNew/PartnerPriority"));
const GrowClientsWealth = dynamic(() => import("components/PartnerHomePageNew/GrowClientsWealth"));
const VisitUs = dynamic(() => import("components/PartnerHomePageNew/VisitUs"));
const MFDistributor = dynamic(() => import("components/MFSolution/MFDistributor"));
const MoneyOrder = dynamic(() => import("components/AboutUsNew/MoneyOrder"));
const ReadyToGrow = dynamic(() => import("components/PartnerHomePageNew/ReadyToGrow"));
const NewFooter = dynamic(() => import("components/NewFooter/NewFooter"));

const Homepage = (props) => {
  const {seoData, statsData, testimonialsData, partnerLogosData, priorityData, helpsData, featuresData, visitUsData, heroData, readyData, brandData, distributorData, moneyOrderData, growWealthContent} = props;
  const [toggleRegister, setToggleRegister] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);


  const handleCloseModal = () => {
    setToggleModal(false);
    const currentScroll = window.scrollY;
    window.history.replaceState(null, "", window.location.pathname);
    window.scrollTo(0, currentScroll);
  };

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const currentScroll = window.scrollY;

      setToggleRegister(hash === "#register");
      setToggleModal(hash === "#login");

      requestAnimationFrame(() => {
        window.scrollTo(0, currentScroll);
      });
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <>
      <PageWrapper>
        {<PartnerGlobalStyle />}

        <Head>
          <title>{seoData?.title}</title>
          <meta content={seoData?.title} name="title" />
          <meta content={seoData?.description} name="description" />
          <meta content={seoData?.keywords} name="keywords" />

          <meta content="website" property="og:type" />
          <meta content={seoData?.canonicalUrl} property="og:url" />
          <meta content={seoData?.title} property="og:title" />
          <meta content={seoData?.description} property="og:description" />
          <meta content={seoData?.ogImage} property="og:image" />
          <meta content="Wealthy" property="og:site_name" />

          <meta content="summary_large_image" property="twitter:card" />
          <meta content="@wealthy_in" name="twitter:site" />
          <meta content={seoData?.canonicalUrl} property="twitter:url" />
          <meta content={seoData?.title} property="twitter:title" />
          <meta content={seoData?.description} property="twitter:description" />
          <meta content={seoData?.ogImage} property="twitter:image" />

          <link href={seoData?.canonicalUrl} rel="canonical" />
          <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
          <link as="image" href="https://i.wlycdn.com/wealthy-home-page/partner-home-hero.jpg" rel="preload" />
          {WealthyEnv.IS_PRODUCTION ? (
            <link
              as="font"
              crossOrigin="anonymous"
              href={`${WealthyEnv.WEALTHY_FONT}/maven-pro-regular.woff`}
              rel="preload"
              type="font/woff"
            />
          ) : null}

          {seoData?.schema && (
            <script
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(seoData.schema)
              }}
              type="application/ld+json"
            />
          )}

          <link href="/static/next/css/header-footer.css" rel="stylesheet" />

          <script
            defer
            src={`https://www.google.com/recaptcha/api.js?render=${WealthyEnv.RECAPTCHA_SITEKEY}`}
          />

        </Head>
        <SegmentAnalytics />
        <ToastContainer />
        <div id="login" style={{display: toggleModal ? "block" : "none"}}>
          <GetStartedModal
            setToggleModal={handleCloseModal}
            toggleModal={toggleModal}
          />
        </div>

        <div id="register">
          <Register />
        </div>

        <div id="register-thankyou">
          <ThankYouModalContainer>
            <ThankYouModalContentContainer>
              <NewThankYou step={4} />
            </ThankYouModalContentContainer>
          </ThankYouModalContainer>
        </div>

        <HeaderV2
          isHomePage
          isPartnerPage
          backgroundColor={"#F8F8F8"}
          color={"#000000"}
          logo={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`}
        />

        {/* <AdvisoryNotice /> */}
        <HeroSection heroData={heroData} />
        <StatsSection data={statsData} />
        <HowWealthyHelps helpsData={helpsData} />
        <HomePageFeatures features={featuresData} />
        <CreateBrand brandData={brandData} />
        <PartnerPriority priorityData={priorityData} />
        <GrowClientsWealth content={growWealthContent} partnerLogos={partnerLogosData} testimonials={testimonialsData} />
        <VisitUs visitUsData={visitUsData} />
        <MFDistributor distributorData={distributorData} />
        <ReadyToGrow readyData={readyData} />
        <MoneyOrder moneyOrderData={moneyOrderData} />
        <NewFooter />
      </PageWrapper >
    </>
  );
};
const ThankYouModalContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: #261E38;
  z-index: 999;
`;

const ThankYouModalContentContainer = styled.div`
  position: absolute;
  display: block;
  line-height: 1.8;
  width: 100rem;
  height: 64rem;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0px 12px 24px rgba(0,0,0,0.2);
  border-radius: 2.4rem;
  background-color: #f5f5f5;
  color: #34495E;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 85%;
    padding: 4rem 2rem;
  }
`;

const PageWrapper = styled.div`
  overflow-x: hidden;
  #register, #register-thankyou, #share {
    transition: all 0s, opacity 300ms ease-in-out;
    opacity: 0;
    visibility: hidden;
  }
  #register:target, #register-thankyou:target, #share:target {
    transition: all 0s, opacity 300ms ease-in-out;
    opacity: 1;
    visibility: visible;
    position: fixed;
    z-index: 999;
    & > div > div {
      transform: translate(-50%, -50%);
      transition: all 0.25s ease-in-out;
    }
  }
`;
export async function getStaticProps () {
  const statsData = [
    {
      id: 1,
      icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-stats-icon1.jpg`,
      number: "Rs 8,000",
      label: "Crore+ AUM"
    },
    {
      id: 2,
      icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-stats-icon2.jpg`,
      number: "40+",
      label: "Offices"
    },
    {
      id: 3,
      icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-stats-icon3.jpg`,
      number: "400+",
      label: "Employees"
    },
    {
      id: 4,
      icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-stats-icon4.jpg`,
      number: "14,000+",
      label: "Wealth Partners"
    }
  ];

  const seoData = {
    title: "Wealthy – Mutual Fund Distributor Platform & App in India",
    description: "Wealthy helps Mutual Fund Distributors grow their business with AI tech, client onboarding, portfolio tools and dedicated support. Join 14,000+ Wealth Partners across India.",
    keywords: "mutual fund distributor platform, MFD app, IFA platform India,  wealth management software, mutual fund distribution software, mutual fund distribution",
    canonicalUrl: `${WealthyEnv.URL}`,
    ogImage: "https://i.wlycdn.com/wealthy-home-page/partner-metaimage-new.png",
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: "Wealthy",
          url: `${WealthyEnv.URL}`,
          publisher: {
            "@type": "Organization",
            name: "Wealthy"
          },
          logo: "https://i.wlycdn.com/wealthy-home-page/wealthy-new-purple-logo.svg",
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "partner support",
            email: "partner.support@wealthy.in",
            areaServed: "IN"
          },
          sameAs: [
            "https://www.linkedin.com/company/wealthy",
            "https://twitter.com/wealthy"
          ]
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Partner",
              item: `${WealthyEnv.URL}/partner`
            }
          ]
        }
      ]
    }
  };

  const testimonialsData = [
    {
      videoId: "f_2eCcaQCbY",
      text: "We are so happy that we are associated with Wealthy, which is a forward thinking platform. Its product research is ahead of a lot in the market & from a tech back end, you get the best in the country.",
      name: "Swarup Mohanty, Vice Chairman & CEO",
      company: "Mirae Asset Investment Managers (India)"
    },
    {
      videoId: "tpQ6CD0EjCU",
      text: "Wealthy has done an incredible job to connect partners with investors & AMCs & building that bridge through tech which is what's critical, and I think that's going to help the overall industry to scale.",
      name: "Avinash Satwalekar, President",
      company: "Franklin Templeton Asset Management (India)"
    },
    {
      videoId: "7HyHgewgoLY",
      text: "I associated with Wealthy because I saw a lot of backup that was available for me as a Mutual Fund Distributor. With Wealthy's app & support, I can run my operations from anywhere in the world.",
      name: "Our Wealth Partners"
    },
    {
      videoId: "WTlHaBZEr7c",
      text: "I'm sure in the coming years Wealthy is going to play a big role in revolutionizing the reach of capital market products into tier 2, tier 3 cities and beyond.",
      name: "Aashish Sommaiyaa, Executive Director & CEO",
      company: "WhiteOak Capital Management"
    }
  ];

  const partnerLogosData = [
    {src: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-client-wealth-logo1.jpg`, alt: "Mirae Asset Investment Managers Logo"},
    {src: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-client-wealth-logo2.jpg`, alt: "Franklin Templeton Asset Management Logo"},
    {src: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-client-wealth-logo3.jpg`, alt: "Wealthy Partner Logo"},
    {src: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-client-wealth-logo4.jpg`, alt: "WhiteOak Capital Management Logo"},
    {src: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-client-wealth-logo5.png`, alt: "Bombay Institutional Investors Logo"}
  ];

  const growWealthContent = {
    heading: "Grow your Client's Wealth",
    subHeading: "We're a team of investment experts with the pedigree of IIT-IIM and decades of experience in big names such as Citibank, Morgan Stanley, Edelweiss and Axis Mutual Fund.",
    subHeadingSmall: "But don't just take our word for how we're the #1 wealth platform for Advisors/Distributors in India – Hear it from our Partners and Industry Leaders.",
    arrowLeft: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-arrow-left.svg`,
    arrowRight: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-arrow-right.svg`,
    defaultTestimonials: [
      {
        videoId: "f_2eCcaQCbY",
        text: "We are so happy that we are associated with Wealthy...",
        name: "Swarup Mohanty, Vice Chairman & CEO",
        company: "Mirae Asset Investment Managers (India)"
      }
    ]
  };

  const heroData = {
    titleLines: ["Grow And Manage Wealth,", "the Smarter Way"],
    description: "Wealthy brings India’s investors and Mutual Fund Distributors onto one advanced platform - powerful tech, deep product research, learning &  full support, and a thoughtfully designed, seamless experience - so wealth gets built with confidence.",
    ctaText: "Talk To Us",
    demoText: "View Demo",
    videoId: "3AUkLuKP-D4",
    playIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-home-getin-touch.svg`,
    chatIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-play.svg`,
    heroImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-hero.jpg`
  };

  const readyData = {
    heading: {
      main: "Ready to grow your Mutual Fund Distribution Business ",
      highlight: "exponentially?"
    },
    description: "At Wealthy, we believe managing a wealth business should be simple and its impact should be big. We take care of your tech, products and product researches along with marketing and support. Join Us.",
    ctaText: "Sign Up Today",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-grow-together.jpg`,
    buttonIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-home-chat.svg`
  };

  const brandData = {
    heading: "Effortless Onboarding & Your Own Investment Space",
    description: "Clients get a smooth, paperless start; while partners get a personalised webpage with logo, photo, tagline and contact details - available in 9 languages with a built-in inquiry form. Every lead syncs to the dashboard with instant email and WhatsApp alerts.",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-client-onboard-image.svg`
  };

  const distributorData = {
    heading: {
      line1: "Join India’s fastest growing platform for",
      highlight: "Mutual Fund Distributors (MFDs)"
    },
    description:
      "Empanel with Wealthy in just 60 seconds* and avail exclusive benefits.",
    ctaText: "Sign Up Now",
    videoId: "7Z-q01OwpZ0",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-mf-distributor-image.jpg`,
    playIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-mf-distributor-button.svg`
  };


  const moneyOrderData = {
    title: "Wealthy Newsletters",
    subtitle: "India & The World - Decoded Weekly.",
    descriptionItems: [
      "Markets, Business & Economy, Simplified",
      "Indian & Global Market Insights",
      "The Investment Angle Behind Every Headline"
    ],
    spotifyLink: "https://open.spotify.com/show/5IsaQk2l5L366VK3bIeXgy?si=k_MzeCyjSrSGTjLjTktWsA",
    planeImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/money-order-plane-about-us.png`,
    spotifyImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/money-order-spotify-icon-about-us.png`
  };

  const priorityData = {
    heading: "Built Around the People Who Matter",
    cards: [
    {
      id: 1,
      desktop: {
        title: "Dedicated Partner (MFD) Support & Training",
        subtitle: "Research, Operations and Marketing support",
        description:
          "A dedicated relationship manager for every operational and service need, plus training programmes (Partner Specific), content and marketing support to help you grow."
      },
      mobile: {
        title: "Dedicated Partner (MFD) Support & Training",
        subtitle: "Research, Operations and Marketing support",
        description:
          "A dedicated relationship manager for every operational and service need, plus training programmes (Partner Specific), content and marketing support to help you grow."
      },
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-priority-image1.jpg`,
      iconImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-card1.svg`,
      cardColor: "#F7F9FF"
    },
    {
      id: 2,
      desktop: {
        title: "Instant Tracking & Updates",
        subtitle: "An app your whole portfolio lives in",
        description:
          "A thoughtfully designed Investor app to track investments anytime - no more late-night (is my portfolio up or down today?) calls."
      },
      mobile: {
        title: "Instant Tracking & Updates",
        subtitle: "An app your whole portfolio lives in",
        description:
          "A thoughtfully designed app to track investments anytime - no more late-night (is my portfolio up or down today?) calls."
      },
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-priority-image3.jpg`,
      iconImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-card2.svg`,
      cardColor: "#F9F6FF"
    },
    {
      id: 3,
      desktop: {
        title: "Guidance & Development ",
        subtitle: "Helping everyone grow",
        description:
          "Ongoing upskilling, expert research and hands-on support so both investors and advisors stay ahead."
      },
      mobile: {
        title: "Guidance & Development",
        subtitle: "Helping everyone grow",
        description:
          "Ongoing upskilling, expert research and hands-on support so both investors and advisors stay ahead."
      },
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-priority-image2.jpg`,
      iconImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-icon3.svg`,
      cardColor: "#FFF9F6"
    }
    ]
  };

  const helpsData = {
    questionHeading: "Invest, Track and Grow - All in One Place",
    desktopHeading: "AI-Powered App for Investors and Wealth Partners",
    mobileHeading: "Grow Your Business",
    appName: "Download Wealthy Partner App",
    downloadCount: "100k + Downloads",
    playStoreUrl: `${WealthyEnv.PARTNER_APP_NEW_PLAYSTORE_LINK}`,
    appStoreUrl: `${WealthyEnv.PARTNER_APP_NEW_APPSTORE_LINK}`,
    wealthyAi: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-wealthy-ai.jpg`,
    appIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-wealthy-partner-logo.png`,
    playStoreIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-play-store.png`,
    appStoreIcon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-app-store.png`,
    featureData: [
      {
        id: 1,
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-digital-icons1.svg`,
        altText: "Star Icon",
        text: "Complete KYC and start your first investment in under 2 minutes, powered by AI."
      },
      {
        id: 2,
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-diamond.svg`,
        altText: "Diamond Icon",
        text: "Receive and act on tailored investment proposals built around your goals."
      },
      {
        id: 3,
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-digital-icons3.jpg`,
        altText: "Calendar Icon",
        text: "Industry-first SIP features with step-up and multi-day options."
      },
      {
        id: 4,
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-digital-icon4.jpg`,
        altText: "Star Icon",
        text: "Make smarter choices with Wealthy Baskets and the Calculators."
      },
      {
        id: 5,
        icon: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-digital-icon5.jpg`,
        altText: "Star Icon",
        text: "Access 10+ ready reports including Holdings, AUM Breakdown and more."
      }
    ]
  };

  const visitUsData = {
    title: "Join Us!",
    subtitle: {
      desktop: "The talented team of engineers, product researchers and partner support teams are dedicated to making Wealthy a platform that will transform the lives of Wealth Professionals and Investors in India and beyond.",
      mobile: "Wealthy is headquartered in Bengaluru with offices in cities across India such as Kolkata, Ahmedabad, Lucknow, Delhi, and Mumbai."
    },
    stats: [
      {title: "40+ offices", subtitle: "Across India"},
      {title: "400+ Team Members", subtitle: "Across cities and countries"}
    ],
    ctaHeading: "Join Us!",
    ctaText: "Get in Touch",
    mobImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/india-map-updated-mob.png`,
    mapImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/india-map-updated-homepage.png`,
    mapImageWidth: "80%",
    mapImagePadding: "1rem 0"
  };

  const featuresData = [
    {
      description: "Our platform houses various financial products across mutual funds, stocks, fixed deposits, bonds, insurance, PMS, and AIF. There’s a product for every need and this ensures you develop a long lasting relationship with your clients.",
      heading: "Mutual Funds, Stocks, Insurance & More",
      hasLottie: true,
      reverse: true,
      subtitle: "Wide-range of financial products"
    },
    {
      customMargin: "0rem auto 0rem auto",
      description: "A complete financial ecosystem to invest and manage financial products in one place. From seamless onboarding to real-time portfolio and earnings tracking, everything is built in - saving time, enabling better decisions, and building trust between advisors and the clients they serve.",
      heading: "Smart Technology for Wealth That Grows",
      image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-home-smart-tech.jpg`,
      reverse: false,
      subtitle: "You focus on your goals, we handle the rest"
    }
  ];

  return {
    props: {
      seoData,
      statsData,
      testimonialsData,
      partnerLogosData,
      priorityData,
      helpsData,
      featuresData,
      visitUsData,
      heroData,
      readyData,
      brandData,
      distributorData,
      moneyOrderData,
      growWealthContent
    }
  };
}

export default Homepage;
